import { PaperProps } from "@mui/material";
import { memo, useMemo } from "react";
import DraggablePaper from "./DraggablePaper";

export const useMemoizedDraggablePaper = (
  draggable: boolean,
  dragHandleSelector: string,
) => {
  return useMemo(() => {
    return memo((props: PaperProps) => (
      <DraggablePaper
        {...props}
        dragHandleSelector={dragHandleSelector}
        disabled={!draggable}
      />
    ));
  }, [dragHandleSelector, draggable]);
};
